<div class="row m-b-xs" (dblclick)="editModeOn()">
    <div *ngIf="title"
         [ngClass]="{'col-sm-6': longTitle, 'col-sm-3': !longTitle}"
         class="dv-label strong"
         data-toggle="tooltip"
         data-placement="top"
         [title]="tooltipText">
        {{ title }}
    </div>

    <div *ngIf="!editOnly"
         class="dv-value"
         [ngClass]="{'col-sm-6': longTitle, 'hidden': isEditMode, 'col-sm-9': title, 'col-sm-12': !title}">
        <i *ngIf="icon" [ngClass]="icon" class="m-r-sm"></i>

        <span [class]="valueClass">{{ value || '-' }}</span>

        <i *ngIf="!noEdit"
           class="fa fa-pencil pull-right"
           (click)="editModeOn()"
           data-toggle="tooltip"
           data-placement="top"
           title="Edit"></i>
    </div>

    <div class="dv-value-edit"
         [ngClass]="{'col-sm-6': longTitle, 'hidden': !isEditMode, 'col-sm-9': title, 'col-sm-12': !title}">
        <i *ngIf="icon" [ngClass]="icon" class="m-r-sm"> </i>

        <input (keyup.enter)="apply()" [(ngModel)]="value" [type]="type" class="form-control"
               maxlength="255" [required]="required" autocomplete="off">

        <button *ngIf="!editOnly" type="button" (click)="apply()">
            <i class="fa fa-check"></i>
        </button>

        <button *ngIf="!editOnly" type="button" (click)="cancel()">
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/input-field/input-field.template.html